import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../firebase/firebase';
import { checkIsAdmin, getUserData } from '../services/authService';

type UserType = User | null;

interface AuthContextType {
  currentUser: UserType;
  isAdmin: boolean;
  userData: any | null;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType>({
  currentUser: null,
  isAdmin: false,
  userData: null,
  loading: true
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentUser, setCurrentUser] = useState<UserType>(null);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [userData, setUserData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      
      if (user) {
        // Debug logs to help identify the issue
        console.log("Current user UID from Firebase Auth:", user.uid);
        console.log("Current user email:", user.email);
        
        // Check if user is admin
        const adminStatus = await checkIsAdmin(user.uid);
        console.log("Is admin check result:", adminStatus);
        setIsAdmin(adminStatus);
        
        // Get user data
        const data = await getUserData(user.uid);
        console.log("User data from Firestore:", data);
        setUserData(data);
      } else {
        setIsAdmin(false);
        setUserData(null);
      }
      
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    isAdmin,
    userData,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}; 